import React from 'react';
import { TableCell, Typography } from '@mui/material';

interface ValueCellProps {
    value: string;
    originalValue?: string;
    options?: { value: string; label: string }[];
}

const ValueCell: React.FC<ValueCellProps> = ({ value, originalValue, options }) => {
    let isSame = value == originalValue;
    let label = options?.find((option) => option.value == value)?.label;
    if (label == undefined) {
        label = value;
    }else{
        isSame = false;
    }

    return (
        <TableCell sx={{ padding: "8px" }}>
            <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                {isSame ? value : (
                    <>
            <span style={{ textDecoration: "line-through", color: "#999", opacity: 0.7, marginRight: 4 }}>
              {originalValue !== undefined? originalValue + " ⇒ " : ''}
            </span>
                        {/* {options?.length > 0 && originalValue !== null && originalValue != "" ? " ⇒ " : ""} */}
                        {label}
                    </>
                )}
            </Typography>
        </TableCell>
    );
};

export default ValueCell;
